import { NavLink } from "react-router-dom";
import type { LinkProps } from "../../layout/VTabBarLayout";

export default function VTabBarLink({ el }: { el: LinkProps }) {
  return (
    <div className="relative group">
      <NavLink
        // key={el.id}
        className={({ isActive }) =>
          `px-4 flex items-center gap-3 py-[10px] ${
            el.disabled ? "cursor-not-allowed" : ""
          } ${el.id === 1 ? "mb-8" : ""} ${
            isActive ? "bg-custom-highlight-white rounded-2xl" : ""
          }`
        }
        to={el.route}
        end={false}
        onClick={(e) => {
          if (el.disabled) e.preventDefault();
        }}
      >
        {({ isActive }) => (
          <>
            <span
              className={`${
                isActive
                  ? "text-custom-dark-blue-new"
                  : el.disabled
                    ? "text-gray-400/80"
                    : "text-black/50"
              } relative`}
            >
              {el.icon}
              {el.disabled && (
                <span className="text-[6px] absolute top-0 -left-2 text-orange-400 bg-orange-50/80 border border-orange-400 rounded px-[2px] whitespace-nowrap">
                  Coming Soon
                </span>
              )}
            </span>
            <span
              className={`sidebar_label ${
                el.disabled ? "text-gray-400/80" : "text-custom-dark-blue-new"
              }`}
            >
              {el.name}
            </span>
          </>
        )}
      </NavLink>

      {/* on hover tooltip */}
      <div className="absolute left-full top-1/2 -translate-y-1/2 ml-2 z-10 max-w-[200px] w-max p-2 bg-gray-800 text-white text-xs rounded opacity-0 invisible group-hover:visible group-hover:opacity-100 transition-opacity duration-300">
        {el.content}
        <div className="absolute -z-10 left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 w-3 h-3 bg-gray-800 rotate-45"></div>
      </div>
    </div>
  );
}
